/**
 * SoundToggle — компактная кнопка вкл/выкл звука (И7, Часть 4).
 *
 * Состояние хранится в localStorage (kikayoo:sound) через sound.ts. При включении
 * вызывает unlockAudio — это и есть «жест пользователя», разблокирующий AudioContext
 * (autoplay policy). Чистый презентационный компонент над императивным API sound.ts.
 */
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isSoundEnabled, setSoundEnabled, unlockAudio } from '../sound';

export function SoundToggle(): JSX.Element {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState<boolean>(() => isSoundEnabled());
  const toggle = useCallback(() => {
    setEnabled((prev) => {
      const next = !prev;
      setSoundEnabled(next);
      if (next) {
        unlockAudio();
      }
      return next;
    });
  }, []);

  return (
    <button
      type="button"
      className={`btn btn--ghost sound-toggle${enabled ? '' : ' sound-toggle--off'}`}
      onClick={toggle}
      aria-pressed={enabled}
      title={enabled ? t('sound.on') : t('sound.off')}
      aria-label={enabled ? t('sound.turnOff') : t('sound.turnOn')}
      data-testid="sound-toggle"
    >
      <span aria-hidden="true">{enabled ? '🔊' : '🔇'}</span>
    </button>
  );
}
